import { parsePhoneNumber } from 'libphonenumber-js';
import { formatDateTime } from '@icims-design-system/i18next';
import {
  productTypes,
  roles,
  channelTypes,
  filterAutoCompleteChangeTypes,
  INVALID_DATE,
} from 'appConstants';

const DEFAULT_ISO_COUNTRY_CODE = 'US';

export const dedupeOptions = (Options, newOptions) => {
  const updatedOptions = [...Options, ...newOptions];
  const formattedOptions = updatedOptions.map((obj) => [obj.id, obj]);

  return [...new Map(formattedOptions).values()];
};

export function replaceSpecialChars(str, replaceStr = '') {
  return str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, replaceStr);
}

export function convertSort({ filters }) {
  let direction = '+';
  if (filters.reverse) {
    direction = '-';
  }

  direction += filters.order;
  return direction;
}

export function formatPhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return {
      formattedPhoneNumber: '',
      ISO3166CountryCode: '',
    };
  }

  const phoneNumberObj = parsePhoneNumber(phoneNumber, DEFAULT_ISO_COUNTRY_CODE);

  return {
    formattedPhoneNumber: phoneNumberObj.formatNational(),
    ISO3166CountryCode: phoneNumberObj.country,
  };
}

export const formatDateTimeForTableView = (time, language) => {
  if (!time) {
    return INVALID_DATE;
  }
  return formatDateTime(time, 'keyboardDateTime12h', language);
};

export const prune = (obj) => {
  Object.keys(obj).forEach((k) => !obj[k] && delete obj[k]);
  return obj;
};

export const getAccountId = (customerIds) => {
  const textrecruitCustomerId = customerIds.find((c) => c.product === productTypes.TEXT_RECRUIT);

  return textrecruitCustomerId ? textrecruitCustomerId.customerId : '';
};

export const getTabPanelProps = (value) => ({
  value,
  id: `tab-${value}`,
  'aria-controls': `tabpanel-${value}`,
});

const getRoleType = (customerIds) => {
  const textRecruitAccount = customerIds.find((c) => c.product === productTypes.TEXT_RECRUIT) ?? {};
  // TODO: Role enums should be done when Typescript integration is completed.
  // TODO: tracked here: https://jira.icims.net/browse/TXTE-23782 -Amir
  return textRecruitAccount.role || 'User';
};

export const hasUserRole = (customerIds) => {
  const role = getRoleType(customerIds);

  return role === roles.USER;
};

export const hasManagerRole = (customerIds) => {
  const role = getRoleType(customerIds);

  return role === roles.MANAGER;
};

export const hasReporterRole = (customerIds) => {
  const role = getRoleType(customerIds);

  return role === roles.REPORTER;
};

export const hasCustomerAdmin = (customerIds) => {
  const role = getRoleType(customerIds);

  return role === roles.CUSTOMER_ADMIN;
};
export const isTeamWideUser = (customerIds = []) => {
  const textrecruitCustomerId = customerIds.find((c) => c.product === productTypes.TEXT_RECRUIT);
  const { role = '' } = textrecruitCustomerId || {};

  return role === roles.TEAM_WIDE_USER;
};

export const customerWideUser = (customerIds) => {
  const textrecruitCustomerId = customerIds.find((c) => c.product === productTypes.TEXT_RECRUIT);
  const { role = '' } = textrecruitCustomerId;

  return role === roles.CUSTOMER_WIDE_USER;
};

export const hasJobChat = (customerIds) => {
  const jobChatCustomers = (customerIds || []).filter(
    (customer) => customer.product === channelTypes.JOB_CHAT,
  );
  return Boolean(jobChatCustomers.length);
};

export const hasfacebookMessengerEnabled = (customerIds) => {
  const facebookEnabledCustomers = (customerIds || []).filter(
    (customer) => customer.product === channelTypes.FACEBOOK,
  );
  return Boolean(facebookEnabledCustomers.length);
};

export const ariaLabelSelectUnselect = (row, t) =>
  t('select_row', 'Select {{name}}', {
    name: row.data.fullName,
  });

export const stateReducer = ({ state, payload }) => {
  const localState = state;
  Object.keys(payload).forEach((key) => {
    localState[key] = payload[key];
  });
  return localState;
};

export const shouldFetch = (changeType) =>
  (changeType && changeType !== filterAutoCompleteChangeTypes.RESET) || !changeType;
